module.exports = __webpack_public_path__ + "static/media/hygrostaty.fccba8d2.pdf";